import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'fulfillment_inventory',
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_inventory_report.js